import {Component, OnInit} from "@angular/core";
import {ConfigurationService, EntityService} from "@fedeltapointofsale/data-client";
import {Router} from "@angular/router";
import {Config} from "../../config";

@Component({
    selector: "wbo-home-page",
    templateUrl: "./home-page.component.html",
    styleUrls: ["./home-page.component.scss"]
})
export class HomePageComponent implements OnInit {

    public date: Date;

    constructor(
        private configService: ConfigurationService,
        private router: Router
    ) {
        this.date = new Date();
    }

    ngOnInit() {
        this.configService.getBoolean(Config.BI_ENABLED).then(biEnabled => {
            if (biEnabled) {
                EntityService.canGetEntity(this.configService, "bo/bi-dashboard").then(biAuthorised => {
                    if (biAuthorised) {
                        this.router.navigate(["/main/dashboard/-1"], {replaceUrl: true});
                    }
                });
            }
        });
    }
}
